module.exports = __webpack_public_path__ + "static/dp-home-header-e3ebaa6aefcced09a88c6e63e66b6acb.jpg";